<a
  [ngClass]="'custom-button ' + (width ? width : '!w-[200px]')"
  class="text-white"
  [attr.href]="download ? env.origin + '/midias/' + download : href"
  [attr.download]="download"
  [target]="download ? '_blank' : '_self'"
  >{{ text }}</a
>
